// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.studio-settings {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #eff6ff 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Loading State */
.settings-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #eff6ff 100%);
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #0f172a;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.settings-loading p {
  color: #4a5568;
  font-size: 1.1rem;
  font-weight: 500;
}

/* Header */
.settings-header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 30px;
}

.back-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0f172a;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.back-link:hover {
  color: #2563eb;
}

.page-title {
  display: flex;
  align-items: center;
  gap: 15px;
}

.title-icon {
  font-size: 1.8rem;
  color: #0f172a;
}

.page-title h1 {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.saving-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #4a5568;
  font-weight: 500;
}

.saving-indicator .spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #0f172a;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Settings Container */
.settings-container {
  display: flex;
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
}

/* Sidebar */
.settings-sidebar {
  width: 280px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  padding: 30px 0;
}

.settings-nav {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0 20px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 20px;
  border: none;
  background: none;
  color: #4a5568;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.3s ease;
  text-align: left;
  width: 100%;
}

.nav-item:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #0f172a;
}

.nav-item.active {
  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.nav-item svg {
  font-size: 1.1rem;
}

/* Main Content */
.settings-content {
  flex: 1 1;
  padding: 40px;
  overflow-y: auto;
}

.settings-section {
  max-width: 800px;
}

.section-header {
  margin-bottom: 40px;
}

.section-header h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 10px 0;
}

.section-header p {
  color: #4a5568;
  font-size: 1.1rem;
  margin: 0;
}

/* Profile Form */
.profile-form {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.form-section {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid #f7fafc;
}

.form-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.form-section h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 25px 0;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 15px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #0f172a;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

/* Branding Section */
.branding-section {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.logo-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.logo-preview {
  width: 120px;
  height: 120px;
  border: 3px dashed #cbd5e0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  overflow: hidden;
}

.logo-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.logo-preview svg {
  font-size: 2rem;
  color: #a0aec0;
}

.upload-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #f7fafc;
  color: #4a5568;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-btn:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.color-settings {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.color-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.color-group label {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.9rem;
}

.color-input {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-input input[type="color"] {
  width: 50px;
  height: 40px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
}

.color-input span {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #4a5568;
  background: #f7fafc;
  padding: 8px 12px;
  border-radius: 6px;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #f7fafc;
}

.save-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.save-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
}

.save-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Notification Settings */
.notification-settings {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.setting-group {
  margin-bottom: 40px;
}

.setting-group:last-child {
  margin-bottom: 0;
}

.setting-group h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 25px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #f7fafc;
}

.setting-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f7fafc;
}

.setting-item:last-child {
  border-bottom: none;
}

.setting-info h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 5px 0;
}

.setting-info p {
  color: #4a5568;
  font-size: 0.9rem;
  margin: 0;
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbd5e0;
  transition: 0.3s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #0f172a;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

/* Security Settings */
.security-settings {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.security-actions {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #f7fafc;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn.change-password {
  background: #e6fffa;
  color: #234e52;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Danger Zone */
.danger-zone {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.danger-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  background: #fef5f5;
  border: 2px solid #fed7d7;
  border-radius: 15px;
}

.danger-info h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #742a2a;
  margin: 0 0 8px 0;
}

.danger-info p {
  color: #9b2c2c;
  font-size: 0.95rem;
  margin: 0;
}

.danger-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: #e53e3e;
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.danger-btn:hover {
  background: #c53030;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(229, 62, 62, 0.3);
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.delete-modal {
  max-width: 600px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 30px 0;
  border-bottom: 2px solid #f7fafc;
  margin-bottom: 30px;
}

.modal-header h2 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #a0aec0;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #4a5568;
}

/* Password Form */
.password-form {
  padding: 0 30px 30px;
}

.password-input {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input input {
  padding-right: 45px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #a0aec0;
  cursor: pointer;
  padding: 5px;
  transition: color 0.3s ease;
}

.password-toggle:hover {
  color: #0f172a;
}

.modal-actions {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 2px solid #f7fafc;
}

.cancel-btn {
  padding: 12px 24px;
  background: #f7fafc;
  color: #4a5568;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #edf2f7;
}

/* Delete Warning */
.delete-warning {
  padding: 0 30px 30px;
  text-align: center;
}

.warning-icon {
  width: 80px;
  height: 80px;
  background: #fed7d7;
  color: #e53e3e;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  margin: 0 auto 20px;
}

.delete-warning h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #742a2a;
  margin: 0 0 15px 0;
}

.delete-warning p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0 0 25px 0;
  line-height: 1.6;
}

.confirmation-input {
  margin-bottom: 30px;
}

.confirmation-input label {
  display: block;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 10px;
}

.confirmation-input input {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 1rem;
  text-align: center;
  font-weight: 600;
  letter-spacing: 2px;
}

.confirmation-input input:focus {
  outline: none;
  border-color: #e53e3e;
  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .settings-container {
    flex-direction: column;
  }
  
  .settings-sidebar {
    width: 100%;
    padding: 20px 0;
  }
  
  .settings-nav {
    flex-direction: row;
    overflow-x: auto;
    padding: 0 20px;
  }
  
  .nav-item {
    white-space: nowrap;
    min-width: fit-content;
  }
}

@media (max-width: 768px) {
  .settings-header {
    padding: 15px 20px;
    flex-direction: column;
    gap: 15px;
  }
  
  .header-left {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .settings-content {
    padding: 20px;
  }
  
  .profile-form,
  .notification-settings,
  .security-settings,
  .danger-zone {
    padding: 25px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .branding-section {
    flex-direction: column;
    gap: 25px;
  }
  
  .danger-item {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .settings-header {
    padding: 15px;
  }
  
  .settings-content {
    padding: 15px;
  }
  
  .profile-form,
  .notification-settings,
  .security-settings,
  .danger-zone {
    padding: 20px;
  }
  
  .modal-content {
    margin: 10px;
  }
  
  .modal-header,
  .password-form,
  .delete-warning {
    padding-left: 20px;
    padding-right: 20px;
  }
  
  .modal-actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/StudioSettings.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,mEAAmE;AACrE;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".studio-settings {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #ffffff 0%, #eff6ff 100%);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Loading State */\n.settings-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #ffffff 0%, #eff6ff 100%);\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #e2e8f0;\n  border-top: 4px solid #0f172a;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.settings-loading p {\n  color: #4a5568;\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n/* Header */\n.settings-header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 20px 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n\n.back-link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #0f172a;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.back-link:hover {\n  color: #2563eb;\n}\n\n.page-title {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.title-icon {\n  font-size: 1.8rem;\n  color: #0f172a;\n}\n\n.page-title h1 {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.saving-indicator {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.saving-indicator .spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #0f172a;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Settings Container */\n.settings-container {\n  display: flex;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n}\n\n/* Sidebar */\n.settings-sidebar {\n  width: 280px;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(20px);\n  border-right: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 30px 0;\n}\n\n.settings-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  padding: 0 20px;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 15px 20px;\n  border: none;\n  background: none;\n  color: #4a5568;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  text-align: left;\n  width: 100%;\n}\n\n.nav-item:hover {\n  background: rgba(102, 126, 234, 0.1);\n  color: #0f172a;\n}\n\n.nav-item.active {\n  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.nav-item svg {\n  font-size: 1.1rem;\n}\n\n/* Main Content */\n.settings-content {\n  flex: 1;\n  padding: 40px;\n  overflow-y: auto;\n}\n\n.settings-section {\n  max-width: 800px;\n}\n\n.section-header {\n  margin-bottom: 40px;\n}\n\n.section-header h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0 0 10px 0;\n}\n\n.section-header p {\n  color: #4a5568;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n/* Profile Form */\n.profile-form {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.form-section {\n  margin-bottom: 40px;\n  padding-bottom: 30px;\n  border-bottom: 2px solid #f7fafc;\n}\n\n.form-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.form-section h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 25px 0;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 12px 15px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #0f172a;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n/* Branding Section */\n.branding-section {\n  display: flex;\n  gap: 40px;\n  align-items: flex-start;\n}\n\n.logo-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.logo-preview {\n  width: 120px;\n  height: 120px;\n  border: 3px dashed #cbd5e0;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f7fafc;\n  overflow: hidden;\n}\n\n.logo-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.logo-preview svg {\n  font-size: 2rem;\n  color: #a0aec0;\n}\n\n.upload-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background: #f7fafc;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.upload-btn:hover {\n  background: #edf2f7;\n  border-color: #cbd5e0;\n}\n\n.color-settings {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.color-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.color-group label {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 0.9rem;\n}\n\n.color-input {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.color-input input[type=\"color\"] {\n  width: 50px;\n  height: 40px;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.color-input span {\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n  color: #4a5568;\n  background: #f7fafc;\n  padding: 8px 12px;\n  border-radius: 6px;\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 2px solid #f7fafc;\n}\n\n.save-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #0f172a 0%, #2563eb 100%);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.save-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);\n}\n\n.save-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Notification Settings */\n.notification-settings {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.setting-group {\n  margin-bottom: 40px;\n}\n\n.setting-group:last-child {\n  margin-bottom: 0;\n}\n\n.setting-group h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 25px 0;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #f7fafc;\n}\n\n.setting-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 0;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.setting-item:last-child {\n  border-bottom: none;\n}\n\n.setting-info h4 {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0 0 5px 0;\n}\n\n.setting-info p {\n  color: #4a5568;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Toggle Switch */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #cbd5e0;\n  transition: 0.3s;\n  border-radius: 24px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #0f172a;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(26px);\n}\n\n/* Security Settings */\n.security-settings {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.security-actions {\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 2px solid #f7fafc;\n}\n\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.action-btn.change-password {\n  background: #e6fffa;\n  color: #234e52;\n}\n\n.action-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Danger Zone */\n.danger-zone {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 40px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.danger-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px;\n  background: #fef5f5;\n  border: 2px solid #fed7d7;\n  border-radius: 15px;\n}\n\n.danger-info h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #742a2a;\n  margin: 0 0 8px 0;\n}\n\n.danger-info p {\n  color: #9b2c2c;\n  font-size: 0.95rem;\n  margin: 0;\n}\n\n.danger-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: #e53e3e;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.danger-btn:hover {\n  background: #c53030;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(229, 62, 62, 0.3);\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);\n}\n\n.delete-modal {\n  max-width: 600px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 30px 0;\n  border-bottom: 2px solid #f7fafc;\n  margin-bottom: 30px;\n}\n\n.modal-header h2 {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #a0aec0;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-btn:hover {\n  color: #4a5568;\n}\n\n/* Password Form */\n.password-form {\n  padding: 0 30px 30px;\n}\n\n.password-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input input {\n  padding-right: 45px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  color: #a0aec0;\n  cursor: pointer;\n  padding: 5px;\n  transition: color 0.3s ease;\n}\n\n.password-toggle:hover {\n  color: #0f172a;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: flex-end;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 2px solid #f7fafc;\n}\n\n.cancel-btn {\n  padding: 12px 24px;\n  background: #f7fafc;\n  color: #4a5568;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.cancel-btn:hover {\n  background: #edf2f7;\n}\n\n/* Delete Warning */\n.delete-warning {\n  padding: 0 30px 30px;\n  text-align: center;\n}\n\n.warning-icon {\n  width: 80px;\n  height: 80px;\n  background: #fed7d7;\n  color: #e53e3e;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  margin: 0 auto 20px;\n}\n\n.delete-warning h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #742a2a;\n  margin: 0 0 15px 0;\n}\n\n.delete-warning p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0 0 25px 0;\n  line-height: 1.6;\n}\n\n.confirmation-input {\n  margin-bottom: 30px;\n}\n\n.confirmation-input label {\n  display: block;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 10px;\n}\n\n.confirmation-input input {\n  width: 100%;\n  padding: 12px 15px;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 1rem;\n  text-align: center;\n  font-weight: 600;\n  letter-spacing: 2px;\n}\n\n.confirmation-input input:focus {\n  outline: none;\n  border-color: #e53e3e;\n  box-shadow: 0 0 0 3px rgba(229, 62, 62, 0.1);\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .settings-container {\n    flex-direction: column;\n  }\n  \n  .settings-sidebar {\n    width: 100%;\n    padding: 20px 0;\n  }\n  \n  .settings-nav {\n    flex-direction: row;\n    overflow-x: auto;\n    padding: 0 20px;\n  }\n  \n  .nav-item {\n    white-space: nowrap;\n    min-width: fit-content;\n  }\n}\n\n@media (max-width: 768px) {\n  .settings-header {\n    padding: 15px 20px;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .header-left {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n  \n  .settings-content {\n    padding: 20px;\n  }\n  \n  .profile-form,\n  .notification-settings,\n  .security-settings,\n  .danger-zone {\n    padding: 25px;\n  }\n  \n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .branding-section {\n    flex-direction: column;\n    gap: 25px;\n  }\n  \n  .danger-item {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .settings-header {\n    padding: 15px;\n  }\n  \n  .settings-content {\n    padding: 15px;\n  }\n  \n  .profile-form,\n  .notification-settings,\n  .security-settings,\n  .danger-zone {\n    padding: 20px;\n  }\n  \n  .modal-content {\n    margin: 10px;\n  }\n  \n  .modal-header,\n  .password-form,\n  .delete-warning {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  \n  .modal-actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
